import { BaseService } from 'hungry-core2'

import actions from '@actions'

export class VendorPricingAgreementsService extends BaseService {
  setEditVendorPricingAgreement = (vendorPricingAgreement) => {
    this.dispatch(actions.setEditVendorPricingAgreement(vendorPricingAgreement))
  }

  clearEditVendorPricingAgreement = () => {
    this.dispatch(actions.clearEditVendorPricingAgreement())
  }

  setUniversalVendorPricingAgreements = (vendorPricingAgreements) => {
    this.dispatch(
      actions.setUniversalVendorPricingAgreements(vendorPricingAgreements),
    )
  }

  setUniversalVendorPricingAgreementInAgreements = (vendorPricingAgreement) => {
    this.dispatch(
      actions.setUniversalVendorPricingAgreementInAgreements(
        vendorPricingAgreement,
      ),
    )
  }

  setMarketVendorPricingAgreements = (vendorPricingAgreements) => {
    this.dispatch(
      actions.setMarketVendorPricingAgreements(vendorPricingAgreements),
    )
  }

  setMarketVendorPricingAgreementInAgreements = (vendorPricingAgreement) => {
    this.dispatch(
      actions.setMarketVendorPricingAgreementInAgreements(
        vendorPricingAgreement,
      ),
    )
  }

  setVendorMarketVendorPricingAgreements = (vendorPricingAgreements) => {
    this.dispatch(
      actions.setVendorMarketVendorPricingAgreements(vendorPricingAgreements),
    )
  }

  setVendorMarketVendorPricingAgreementInAgreements = (
    vendorPricingAgreement,
  ) => {
    this.dispatch(
      actions.setVendorMarketVendorPricingAgreementInAgreements(
        vendorPricingAgreement,
      ),
    )
  }
}
